export const environment = {
  dev: false,
  production: true,
  siteKey: '6LdjnzUUAAAAALHvZB-PcKSrIbWOn0eCDL2bcNCp',
  useOAuth: true,
  googleLoginProvider: '246713052203-hv9ahuq6e1pirf1khjcusuk2gmuii2mq.apps.googleusercontent.com',
  facebookLoginProvider: '672383723461189',
  linkedinLoginProvider: '86za7qaeq0adhj',
};
